import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import Seo from "../components/Seo";

const FAQ_ITEMS = [
  {
    q: "Μετά τις εξετάσεις των σεμιναρίων, πότε λαμβάνω την πιστοποίηση;",
    a: "Η πιστοποίηση εκδίδεται συνήθως εντός 1–2 εβδομάδων μετά την ολοκλήρωση των εξετάσεων, ανάλογα με τον φορέα πιστοποίησης και το είδος του προγράμματος.",
  },
  {
    q: "Πότε περίπου πραγματοποιείται η πληρωμή από πρόγραμμα voucher;",
    a: "Η πληρωμή των ωφελούμενων από προγράμματα voucher πραγματοποιείται συνήθως εντός 2–3 μηνών μετά την ολοκλήρωση όλων των απαιτούμενων διαδικασιών και ελέγχων από τον αρμόδιο φορέα.",
  },
  {
    q: "Πού μπορώ να απευθυνθώ αν χρειαστώ βοήθεια ή διευκρινίσεις;",
    a: "Μπορείτε να επικοινωνήσετε μαζί μας τηλεφωνικά ή μέσω email. Η ομάδα μας είναι διαθέσιμη για να σας καθοδηγήσει σε κάθε στάδιο της διαδικασίας.",
  },
];

function FAQItem({ q, a, isOpen, onClick }) {
  return (
    <div className="border border-gray-200 rounded-2xl overflow-hidden">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between px-6 py-5 text-left text-gray-900 font-semibold text-base sm:text-lg hover:bg-gray-50 transition"
      >
        <span>{q}</span>
        <FiChevronDown
          className={`ml-4 text-xl transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="px-6 pb-6 text-gray-700 text-base leading-relaxed">
          {a}
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  return (
    <>
      <Seo
        title="Συχνές Ερωτήσεις – ΚΔΒΜ2 ΘΗΣΕΑΣ"
        description="Απαντήσεις για voucher ΔΥΠΑ, προγράμματα κατάρτισης, πιστοποιήσεις και διαδικασίες συμμετοχής από το ΚΔΒΜ2 ΘΗΣΕΑΣ."
        keywords="FAQ ΘΗΣΕΑΣ, συχνές ερωτήσεις voucher, πιστοποίηση, κατάρτιση, ΔΥΠΑ"
        url="https://theseus.edu.gr/faq"
        image="/theseus.png"
        structuredData={faqSchema}
      />

      <section id="faq" className="bg-white py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
              Συχνές Ερωτήσεις
            </h1>
            <p className="mt-4 text-gray-600 text-lg">
              Βρείτε απαντήσεις στις πιο συχνές ερωτήσεις σχετικά με τα προγράμματα
              και τις διαδικασίες μας.
            </p>
          </div>

          <div className="mb-10 rounded-2xl border border-gray-200 bg-gray-50 px-6 py-5 text-center">
            <p className="text-gray-700 text-base sm:text-lg font-medium">
              Χρειάζεστε άμεση βοήθεια;
            </p>

            <div className="mt-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6">
              <a
                href="tel:+30251060020507"
                className="font-semibold text-gray-900 hover:text-blue-600 transition"
              >
                2510 600 205-07
              </a>

              <span className="hidden sm:inline text-gray-300">•</span>

              <a
                href="/contact"
                className="font-semibold text-gray-900 hover:text-blue-600 transition"
              >
                info@theseus.edu.gr
              </a>
            </div>
          </div>

          <div className="space-y-4">
            {FAQ_ITEMS.map((item, i) => (
              <FAQItem
                key={i}
                q={item.q}
                a={item.a}
                isOpen={openIndex === i}
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}